import {
  ListVenueTrustSignalDetailsInput,
  type VenueTrustSignalDetail,
} from '~/shared/venue/venue-trust-signal.api.schema'
import type { VenueTrustSignalDomain } from '~/shared/venue/trust-signals'
import { supabaseClient } from '~/shared/common/supabase/client'
import { parseVenueTrustSignalDetailsFromSupabase } from '~/client/venue/venue-trust-signal.supabase.schema'

export async function fetchVenueTrustSignalDetails(input: {
  venueId: number
  sourceDomain: VenueTrustSignalDomain
  signal?: AbortSignal
}): Promise<VenueTrustSignalDetail[]> {
  const parsedInput = ListVenueTrustSignalDetailsInput.parse({
    venueId: input.venueId,
    sourceDomain: input.sourceDomain,
  })

  const { data, error } = await supabaseClient
    .from('main_venuetrustsignal')
    .select('source_title, source_last_updated_date, source_published_date, venue_description, signal_url')
    .eq('venue_id', parsedInput.venueId)
    .eq('source_domain', parsedInput.sourceDomain)
    .not('source_title', 'is', null)
    .is('deleted_at', null)
    .abortSignal(input.signal)

  if (error) {
    throw new Error(`Failed to load editorial recognition details: ${error.message}`)
  }

  return parseVenueTrustSignalDetailsFromSupabase(data)
}
